import React from 'react';
import { Paragraph2 } from '../../theme/styles';
import './Checkbox.css';

/*
 * <CheckboxLozenge /> component accepts props of:
 *    lozengeText: ""
 *    className: ""
 */

export const CheckboxLozenge = ({ lozengeText = '', className = '' }) => <div className={['lozenge', className].join(' ').trim()}>{lozengeText}</div>;

/*
 * <Checkbox /> component accepts props of:
 * option: {
 *    key: "",
 *    text: "",
 *    subText: "",
 *    rightLozenges: [], // array of lozenges: [{text: "lozengeText", className: "lozengeClassName"}]
 *    checked: true/false,
 *    count: "",
 *    hideCount: true/false/null,
 *    indeterminate: true/false/null,
 *    disabled: true/false/null,
 * }
 *
 * cellClick={} -- cellClick event
 */

export class Checkbox extends React.PureComponent {
    componentDidMount() {
        if (this.inputRef && this.props.option.indeterminate) {
            this.inputRef.indeterminate = true;
        }
    }

    componentDidUpdate(previousProps) {
        if (this.inputRef && (previousProps.indeterminate !== this.props.option.indeterminate)) {
            this.inputRef.indeterminate = this.props.option.indeterminate;
        }
    }

    render() {
        const {
            option,
            id,
            className,
            cellClick,
            size,
            showLockIconOnDisabled,
        } = this.props;

        const {
            key,
            text,
            subText,
            rightLozenges = [],
            checked,
            count,
            hideCount,
            indeterminate,
            disabled,
        } = option;

        return (
            <div
                id={id}
                className={[className, disabled ? 'disabled' : ''].join(' ')}
                style={Paragraph2}
                role="checkbox"
                tabIndex={key || -1}
                aria-checked={checked}
                onClick={!disabled && cellClick ? () => cellClick(option) : null}
            >
                <input
                    className={showLockIconOnDisabled ? 'checkbox-input input-locked' : `dropdownCheckboxInputContainer checkbox-input ${size ?? ''}`}
                    data-testid="checkbox-button"
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    // indeterminate={indeterminate}
                    ref={(input) => {
                        if (input && indeterminate) {
                            this.inputRef = input;
                        }
                    }}
                    readOnly={!!cellClick}
                />
                {text && !subText ? <div className="dropdownCheckboxLabel">{text}</div> : null}

                {text && subText
                    ? (
                        <div className={['dropdownCheckboxLabel', rightLozenges?.length ? 'spaceBetween' : ''].join(' ').trim()}>
                            {text}
                            {subText ? <span className="dropdownCheckboxSubText">{subText}</span> : null}
                            {rightLozenges?.map((lozenge) => <CheckboxLozenge key={lozenge.text} lozengeText={lozenge.text} className={lozenge.className} />)}
                        </div>
                    )
                    : null}
                {count && !hideCount ? <div className="dropdownCheckboxCount">{`(${count})`}</div> : null}
            </div>
        );
    }
}

export default Checkbox;
